export const PORTAL_IDS = {
  subheaderExternalContent: 'subheader-external-content',
  subheaderDropdowns: 'subheader-dropdowns'
}